// src/pages/SsoCallback.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SsoCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("[SSO] SsoCallback href =", window.location.href);
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    console.log("[SSO] token from query =", token);

    if (!token) {
      console.warn("[SSO] no token, going /login");
      navigate("/login", { replace: true });
      return;
    }

    try {
      localStorage.setItem("access_token", token);

      // decode JWT payload to extract email
      const payloadPart = token.split(".")[1];
      const base64 = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
      const json = atob(base64);
      const payload = JSON.parse(json);
      console.log("[SSO] decoded payload =", payload);

      if (payload.email) {
        localStorage.setItem("last_login_email", payload.email);
      }
    } catch (err) {
      console.error("[SSO] error parsing token:", err);
      navigate("/login", { replace: true });
      return;
    }

    // After storing token, let ProtectedOutlet load user and menus
    navigate("/", { replace: true });
  }, [navigate]);

  return null;
}
